import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/home';
import GalleryPage from './pages/galleypage';
import ScrollToTop from './components/Shared/scrolltotop';




function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/gallery" element={<GalleryPage/>} />
      </Routes>
    </Router>
  );
}

export default App;
